import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function resetProcess(token, params) {

    return Api.post(REQUEST_URLS.COMPANY_APPROVAL.RESET_PROCESS, params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    })
}

export default resetProcess;